import { BaseQueryApi, FetchArgs, createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { setCredentials, logOut } from '../../features/auth/authSlice';
import { logRoles } from '@testing-library/react';
import { RootState } from '../store';

const baseQuery = fetchBaseQuery({
    baseUrl: "/api/",
    // baseUrl: "https://localhost:44309/api/",

    credentials: 'include',
    prepareHeaders: (headers, { getState }) => {
        // var auth = (getState as () => RootState)().auth;
        const token = (getState as () => RootState)().auth.token
        if (token) {
            headers.set("Authorization", `Bearer ${token}`)
        }
        return headers
    }
});

const baseQueryWithReauth = async (args: string | FetchArgs, api: BaseQueryApi, extraOptions: {}) => {
    let result = await baseQuery(args, api, extraOptions)

    if (result?.error?.status === 403) {
        console.log('sending refresh token')
        // send refresh token to get new access token 
        const refreshResult = await baseQuery('/Login/refresh-token', api, extraOptions)
        console.log(refreshResult)

        if (refreshResult?.data) {
            const user = (api.getState() as RootState).auth.user
            // store the new token 
            api.dispatch(setCredentials({ accessToken: refreshResult?.data, user }))
            // retry the original query with new access token 
            result = await baseQuery(args, api, extraOptions)
        } else {
            api.dispatch(logOut)
            // api.dispatch(logOut({ }))
        }
    }
    return result
}
export const apiSlice = createApi({
    baseQuery: baseQueryWithReauth,
    endpoints: builder => ({})
})